import { createContext } from "react";

export type TEmailModalContextValue = {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
};

const EmailModalContext = createContext<TEmailModalContextValue>({
  isOpen: false,
  setIsOpen: (_: boolean) => {},
});
export { EmailModalContext };
